import { StyleSheet } from 'react-native';

export const restaurantStyles = StyleSheet.create({
  cardwrapper: {
    backgroundColor: 'white',
    padding: 6,
    borderRadius: 10,
  },

  rcard: {
    width: '20%',

    shadowColor: 'black',
    shadowOpacity: 0.95,

    marginRight: 10,
  },
  dishPic: {
    height: 140,
    width: '100%',
    resizeMode: 'cover',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    backgroundColor: '#808080',
    // marginVertical: 8,
  },
  textArea: {
    padding: 3,
    marginVertical: 1,
    marginaleft: 3,
  },
  brand: {
    fontWeight: 'bold',
  },
  price: {
    color: 'black',
    fontWeight: 'bold',
    marginRight: 6,
  },
  rate: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  genre: {
    color: 'orange',
    fontSize: 12,
  },
  location: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  lText: {
    fontSize: 9,
    color: '#808080',
    marginBottom: 3,
  },
  pin: {
    color: '#808080',
  },
});
